import { clamp } from "@videojs/utils/number";
//#region src/dom/ui/wheel-step.ts
/** @internal */
function createWheelStep(options) {
	return { onWheel(event) {
		if (options.isDisabled()) return;
		const direction = Math.sign(event.deltaY);
		if (direction === 0) return;
		event.preventDefault();
		const stepPercent = options.getStepPercent();
		const currentPercent = options.getPercent();
		const newPercent = clamp(currentPercent - direction * stepPercent, 0, 100);
		options.onValueChange?.(newPercent);
	} };
}
//#endregion
export { createWheelStep };

//# sourceMappingURL=wheel-step.js.map